import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { LinkedinFollowCompany } from "react-social-plugins";
import { PrivacyPolicyModalButton } from "../PrivacyPolicyModalButton/PrivacyPolicyModalButton";
import { NewsletterModalButton } from "../ModalButtons/NewsletterModalButton";
import { SUPPORT } from "../../config/support";

export function Footer() {
    const { t } = useTranslation();

    return (
        <footer className="bg-[#FAFAFA] text-black text-base w-full flex flex-col gap-8 justify-center items-center text-center py-20 mt-64">
            <NewsletterModalButton />
            <div className="mx-12">
                {t("footer-developed-by")}{" "}
                <a
                    className="text-primary-accent-normal no-underline font-bold"
                    href="https://2xper.se"
                    target="_blank"
                    rel="noreferrer"
                >
                    IT-Bolaget Per &amp; Per
                </a>
            </div>
            <LinkedinFollowCompany
                companyId={102977740}
                counter="right" // Or "top"
                lang="en_US"
            />
            <div className="mx-12 flex flex-col">
                {t("footer-support-text")}
                <a
                    className="text-primary-accent-normal no-underline font-bold"
                    href={SUPPORT.emailHref}
                >
                    {t("footer-support-email")}
                </a>
                <a
                    className="text-primary-accent-normal no-underline font-bold"
                    href={SUPPORT.phoneHref}
                >
                    {t("footer-support-phone")}
                </a>
            </div>
            <div className="flex flex-col items-center gap-4">
                <PrivacyPolicyModalButton />
                <Link
                    className="text-primary-accent-normal no-underline font-bold"
                    to="/licenses"
                >
                    {t("attributions")}
                </Link>
            </div>
        </footer>
    );
}
